import { useNavigationStore } from "@utils/navigation/useNavigationStore";

export const getActiveTab = () => useNavigationStore.getState().tab;

export const useActiveTab = () => {
  return useNavigationStore((state) => state.tab);
};
